import mergeDeep from '@/utils/merge-deep';
import { SectionTwoColumnsThemeControls } from '@/components/organisms/SectionTwoColumns/theming';

import block from './block.json';

export const SectionDocumentationThemeControls: ThemeControlsType = mergeDeep(
	SectionTwoColumnsThemeControls,
	{
		// What's displayed
		title: block.title,

		// Unique string/id of the block (= the key used in theme.json)
		slug: block.slug,
	}
);
